import { create } from "zustand";
import { useStoreHome } from "../Home/useStoreHome";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import moment from "moment";
import { MensajeError, MensajeToastExito } from "../../componentes/FuncionesLocales";
import { crearRequestMercaderiasPiSeun, evaluarFiltrosMercaderia } from "../../servicios/mercaderiasPiSeun";
import { obtenerPcIdActual } from "../../servicios/configuracionPc";
import {
  esCategoriaFiscalValida,
  listarCategoriasFiscales,
  seleccionarCategoriaFiscalPredeterminada,
} from "../../servicios/categoriasFiscales";

let claveMercaderiasIngresos = null;
let secuenciaMercaderiasIngresos = 0;

export const useStoreIngresos = create((set, get) => {

  return {
    Proveedor: null,
    Fecha: new Date(),
    Remito: "",
    Lote: "",
    Cantidad: 1,
    Peso: 0,
    EsProductoTerminado: false,
    PrecioCosto: 0,
    PrecioVenta: 0,
    PorcentajeIVA: 21,
    ListaCategoriasFiscales: [],
    CategoriaFiscal: null,
    CargandoCategoriasFiscales: false,
    ErrorCategoriasFiscales: "",
    FechaVencimiento: null,
    Mercaderia: null,
    ListaMercaderias: [],
    Procesando: false,
    buscandoMercaderia: false,
    TabSeleccionado: 0,
    Etiquetas: 1,
    FechasConIngresos: [],

    getUnidadPorDefecto: async () => {
      if (!useStoreHome.getState().EmpresaId || !get().Mercaderia || get().Mercaderia.Id <= 0) { return; }
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        Id: get().Mercaderia.Id
      };
      try {
        const data = await _Componentes_WebApiCalls_Post("Mercaderias/GetUnidadPorMercaderia", sParametros);
        if (data.error) MensajeError(data.error);
        else set({ Unidad: data.data });
      } catch (error) {
        MensajeError(error.message);
      }
    },

    limpiarResultadosMercaderias: () => {
      claveMercaderiasIngresos = null;
      secuenciaMercaderiasIngresos += 1;
      set({ ListaMercaderias: [], buscandoMercaderia: false });
    },
    getMercaderia: async ({ codigo = "", descripcion = "", signal } = {}) => {
      const evaluacion = evaluarFiltrosMercaderia({ codigo, descripcion });
      if (!evaluacion.valido) { get().limpiarResultadosMercaderias(); return []; }
      if (claveMercaderiasIngresos === evaluacion.clave) return get().ListaMercaderias;
      const miSecuencia = ++secuenciaMercaderiasIngresos;
      claveMercaderiasIngresos = evaluacion.clave;
      const sParametros = crearRequestMercaderiasPiSeun(useStoreHome.getState().EmpresaId, 16, evaluacion.filtros);
      if (!sParametros.EmpresaId) return [];
      set({ buscandoMercaderia: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/MercaderiasPiSeun", sParametros, { signal });
        if (data.aborted) return [];
        if (data.error) {
          if (miSecuencia === secuenciaMercaderiasIngresos) claveMercaderiasIngresos = null;
          return { error: data.error };
        }
        const lista = data.data?.Lista || [];
        if (miSecuencia === secuenciaMercaderiasIngresos) set({ ListaMercaderias: lista });
        return lista;
      } catch (error) {
        if (miSecuencia === secuenciaMercaderiasIngresos) claveMercaderiasIngresos = null;
        return { error: error.message };
      } finally { if (miSecuencia === secuenciaMercaderiasIngresos) set({ buscandoMercaderia: false }); }
    },

    getUnidades: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoUnidades) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, iFiltro: 16 };
      set({ buscandoUnidades: true }); try {
        const data = await _Componentes_WebApiCalls_Post("Combos/Unidades", sParametros);
        if (data.error) {
          MensajeError(data.error);

        } else { set({ ListaUnidades: data.data.Lista }); }
      } catch (error) {
        MensajeError(error.message);

      } finally {
        set({ buscandoUnidades: false });
      }
    },

    getCategoriasFiscales: async () => {
      const EmpresaId = useStoreHome.getState().EmpresaId;
      if (!EmpresaId || get().CargandoCategoriasFiscales) return [];
      set({ CargandoCategoriasFiscales: true, ErrorCategoriasFiscales: "" });
      try {
        const respuesta = await listarCategoriasFiscales({ EmpresaId });
        if (respuesta.error) {
          set({ ErrorCategoriasFiscales: respuesta.error });
          return [];
        }
        const lista = respuesta.data?.Lista || [];
        const actual = get().CategoriaFiscal;
        const seleccion = lista.find((item) => item.Id === actual?.Id && item.Version === actual?.Version)
          || seleccionarCategoriaFiscalPredeterminada(lista);
        set({
          ListaCategoriasFiscales: lista,
          CategoriaFiscal: seleccion,
          PorcentajeIVA: seleccion?.PorcentajeIVA ?? 21,
        });
        return lista;
      } catch (error) {
        set({ ErrorCategoriasFiscales: error.message || "No se pudieron cargar las categorías fiscales." });
        return [];
      } finally {
        set({ CargandoCategoriasFiscales: false });
      }
    },

    ListaProveedores: [],
    buscandoProveedores: false,
    getProveedores: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoProveedores) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ buscandoProveedores: true }); try {
        const data = await _Componentes_WebApiCalls_Post("Combos/Proveedores", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else { set({ ListaProveedores: data.data.Lista }); }
      } catch (error) {
        MensajeError(error.message);
      } finally { set({ buscandoProveedores: false }); }
    },

    InsertOk: false,
    insertRegistro: async () => {
      if (get().Procesando) { return; }
      const fechaStr = moment(get().Fecha).format("YYYY-MM-DD");
      const esProductoTerminado = get().EsProductoTerminado === true;
      const mercaderiaNueva = !Number(get().Mercaderia?.Id);
      const categoriaFiscal = get().CategoriaFiscal;
      if (mercaderiaNueva && !esCategoriaFiscalValida(categoriaFiscal)) {
        MensajeError("Debe seleccionar una categoría fiscal para la mercadería nueva.");
        return;
      }
      const sParametros = {
        OperadorId: localStorage.getItem("Id") || 0,
        PcId: obtenerPcIdActual(),
        Fecha: fechaStr,
        Remito: get().Remito,
        Proveedor: get().Proveedor && get().Proveedor.Id ? get().Proveedor : { Id: 0, sDescripcion: get().Proveedor },
        Mercaderia: get().Mercaderia && get().Mercaderia.Id ? get().Mercaderia : { Id: 0, sDescripcion: get().Mercaderia },
        Lote: get().Lote,
        Cantidad: esProductoTerminado ? get().Cantidad : get().Peso,
        Etiquetas: get().Etiquetas,
        Peso: esProductoTerminado ? 0 : get().Peso,
        FechaVencimiento: get().FechaVencimiento ? moment(get().FechaVencimiento).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        EmpresaId: useStoreHome.getState().EmpresaId,
        Unidad: get().Unidad && get().Unidad.Id ? get().Unidad : { Id: 0, sDescripcion: get().Unidad },
        EsProductoTerminado: esProductoTerminado,
        PrecioCosto: esProductoTerminado ? Number(get().PrecioCosto) || 0 : 0,
        PrecioVenta: esProductoTerminado ? Number(get().PrecioVenta) || 0 : 0,
        CategoriaFiscalId: mercaderiaNueva ? Number(categoriaFiscal?.Id) || 0 : 0,
        CategoriaFiscalVersion: mercaderiaNueva ? Number(categoriaFiscal?.Version) || 0 : 0,
        PorcentajeIVA: mercaderiaNueva ? Number(categoriaFiscal?.PorcentajeIVA) || 0 : Number(get().PorcentajeIVA) || 0,
        ConSinIVA: mercaderiaNueva ? Boolean(categoriaFiscal?.ConSinIVA) : true,
        PrecioFinalUnitario: esProductoTerminado ? Number(get().PrecioVenta) || 0 : 0,
        ListaPrecioId: 0,
      };

      set({ Procesando: true });
      try {
        const endpoint = esProductoTerminado
          ? "IngresosSinOrden/InsertProductoTerminado"
          : "IngresosSinOrden/InsertPiSeun";
        const data = await _Componentes_WebApiCalls_Post(endpoint, sParametros);
        if (data.error) {
          console.log(data);
          MensajeError(data.error);
        } else {
          set({ InsertOk: true });
          get().getDetalleGrillaPantalla();
          get().limpiarCampos();
          get().getUnidades && get().getUnidades();
          get().limpiarResultadosMercaderias();
          get().getProveedores && get().getProveedores();
          MensajeToastExito(esProductoTerminado
            ? "Se ingresó el producto terminado correctamente."
            : "Se ingresaron los productos correctamente.");
          get().getFechas();
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ Procesando: false });
      }
    },

    limpiarCampos: () => {
      set({
        Fecha: new Date(),
        Lote: "",
        Peso: 0,
        Cantidad: 1,
        PrecioCosto: 0,
        PrecioVenta: 0,
        CategoriaFiscal: seleccionarCategoriaFiscalPredeterminada(get().ListaCategoriasFiscales),
        PorcentajeIVA: seleccionarCategoriaFiscalPredeterminada(get().ListaCategoriasFiscales)?.PorcentajeIVA ?? 21,
        FechaVencimiento: null,
        Mercaderia: null,
        Etiquetas: 1
      });
    },

    limpiezaTotal: () => {
      set({
        Proveedor: null,
        Fecha: new Date(),
        Remito: "",
        Lote: "",
        Peso: 0,
        Cantidad: 1,
        EsProductoTerminado: false,
        PrecioCosto: 0,
        PrecioVenta: 0,
        CategoriaFiscal: seleccionarCategoriaFiscalPredeterminada(get().ListaCategoriasFiscales),
        PorcentajeIVA: seleccionarCategoriaFiscalPredeterminada(get().ListaCategoriasFiscales)?.PorcentajeIVA ?? 21,
        FechaVencimiento: null,
        Mercaderia: null,
        Etiquetas: 1
      });
    },

    buscandoDetalle: false,
    ListaDetalle: [],
    FechaHasta: null,
    getDetalle: async (fechaParam, fechaHastaParam) => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoDetalle) { return; }

      const fechaAConsultar = fechaParam
        ? moment(fechaParam).format("YYYY-MM-DD")
        : moment(get().Fecha).format("YYYY-MM-DD");

      const fechaHastaAConsultar = fechaHastaParam
        ? moment(fechaHastaParam).format("YYYY-MM-DD")
        : moment(get().FechaHasta ? get().FechaHasta : get().Fecha).format("YYYY-MM-DD");

      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        Id: 0,
        Fecha: fechaAConsultar,
        FechaHasta: fechaHastaAConsultar,
      };

      set({ buscandoDetalle: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresosSinOrden/GrillaDetallePiSeun", sParametros);
        if (data.error) {
          MensajeError( data.error);
        } else {
          set({ ListaDetalle: data.data.Lista });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ buscandoDetalle: false });
      }
    },

    getDetalleGrillaPantalla: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoDetalle) { return; }

      
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        Id: 0,
        Fecha: moment(get().Fecha).format("YYYY-MM-DD"),
        FechaHasta: moment(get().Fecha).format("YYYY-MM-DD"),
      };

      set({ buscandoDetalle: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresosSinOrden/GrillaDetallePiSeun", sParametros);
        if (data.error) {
          MensajeError( data.error);
        } else {
          set({ ListaDetalleGrilla: data.data.Lista });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ buscandoDetalle: false });
      }
    },

    Eliminando: false,
    Seleccionados: [],
    EliminarOk: false,
    eliminarSeleccionados: async () => {
      const sel = get().Seleccionados || []; const ids = sel.map(item => {
        if (typeof item === 'number') return item;
        if (typeof item === 'string') return Number(item);
        return Number(item?.IdentificadorId ?? item?.IdentificadorID);
      }).filter(n => Number.isFinite(n) && n > 0);
      if (ids.length === 0) return; if (!useStoreHome.getState().EmpresaId || get().Eliminando) { return; }
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        Barras: JSON.stringify(ids.map(id => ({ IdentificadorId: id }))),
        OperadorId: Number(localStorage.getItem("Id")) || 0
      };
      set({ Eliminando: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresosSinOrden/EliminarBarras", sParametros);
        if (data.error) {
          MensajeError(data.error);

        } else {
          set({ EliminarOk: true }); set({ Seleccionados: [] });
          get().getDetalleGrillaPantalla();
          get().getFechas();
        }
      } catch (error) {
        MensajeError(error.message );
      } finally { set({ Eliminando: false }); }
    },

    eliminarPorRemito: async (remito) => {
      const { ListaDetalle } = get();
      const ids =
        (ListaDetalle || []).filter(r => String(r.sRemito).trim() === String(remito).trim())
          .map(r => Number(r.IdentificadorId)).filter(n => Number.isFinite(n) && n > 0);
      set({ Seleccionados: ids });
      get().eliminarSeleccionados();
    },

    buscandoFechas  : false,
    getFechas: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoFechas) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ buscandoFechas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("IngresosSinOrden/DistintasFechas", sParametros);
        
        if (data.error) {
          MensajeError(data.error);
        } else {
          const fechas = [];
          for (const item of data.data.Lista) {
            if (item.Fecha) { 
              fechas.push(new Date(item.Fecha))
            }
          }
          set({ FechasConIngresos: fechas });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ buscandoFechas: false });
      }
    },
  };
});
